<template>
    <v-layout wrap justify-center align-center>

        <v-flex xs12 sm2 pa-2 text-left>
            <div class="body-1">OD</div>
        </v-flex>

        <v-flex xs12 sm3 pa-2>
            <v-autocomplete :items="sphOptions"
                            menu-props="auto"
                            auto-select-first
                            label="Sph"
                            v-model="glassesODSph"
                            :readonly="readonly">
                <template v-slot:no-data="">
                    <div class="caption pa-2 text-center">valor no encontrado</div>
                </template>
            </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm3 pa-2>

            <v-autocomplete :items="cylOptions"
                            menu-props="auto"
                            auto-select-first
                            label="Cyl"
                            @keydown.enter.prevent="()=>{}"
                            v-model="glassesODCyl"
                            :readonly="readonly">
                <template v-slot:no-data="">
                    <div class="caption pa-2 text-center">valor no encontrado</div>
                </template>
            </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm3 pa-2>
            <v-combobox
                    :items="degrees"
                    menu-props="auto"
                    auto-select-first
                    v-model="glassesODDegrees"
                    :readonly="readonly" >
                <template v-slot:no-data="">
                </template>
            </v-combobox>
        </v-flex>


        <v-flex xs12 class="hidden-sm-and-up">
            <v-divider ></v-divider>
        </v-flex>

        <v-flex xs12 sm2 pa-2 text-left>
            <div  class="body-1">OI</div>
        </v-flex>

        <v-flex xs12 sm3 pa-2>
            <v-autocomplete :items="sphOptions"
                            menu-props="auto"
                            auto-select-first
                            label="Sph"
                            v-model="glassesOISph"
                            :readonly="readonly">
                <template v-slot:no-data="">
                    <div class="caption pa-2 text-center">valor no encontrado</div>
                </template>
            </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm3 pa-2>
            <v-autocomplete :items="cylOptions"
                            menu-props="auto"
                            auto-select-first
                            label="Cyl"
                            v-model="glassesOICyl"
                            :readonly="readonly">
                <template v-slot:no-data="">
                    <div class="caption pa-2 text-center">valor no encontrado</div>
                </template>
            </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm3 pa-2>
            <v-combobox :items="degrees"
                            auto-select-first
                            v-model="glassesOIDegrees"
                            :readonly="readonly">
                <template v-slot:no-data="">

                </template>
            </v-combobox>
        </v-flex>

        <v-flex xs12 sm5 pa-2 mt-3></v-flex>

        <v-flex xs12 sm3 pa-2 mt-3>
            <v-autocomplete :items="addOptions"
                            auto-select-first
                            label="Add. Cerca"
                            v-model="glassesAdd"
                            :readonly="readonly">
                <template v-slot:no-data="">
                    <div class="caption pa-2 text-center">valor no encontrado</div>
                </template>
            </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm3 pa-2 mt-3>
          <v-text-field
            v-model="glassesDP"
            label="DP"
            :readonly="readonly"
            clearable
            return-masked-value
            mask="##/##"
            @keyup.enter="setGlasses"
            @blur="setGlasses"
          />
        </v-flex>


    </v-layout>
</template>
<script>

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['glasses', 'readonly', 'eventId'],
        data(vm){
            return {
                updatingGlasses: false,
                glassesOIDegrees: vm.glasses && vm.glasses.oi_degrees || '0º',
                glassesOICyl: vm.glasses && vm.glasses.oi_cyl || '0.00',
                glassesOISph: vm.glasses && vm.glasses.oi_sph || '0.00',

                glassesODDegrees: vm.glasses && vm.glasses.od_degrees || '0º',
                glassesODCyl: vm.glasses && vm.glasses.od_cyl || '0.00',
                glassesODSph: vm.glasses && vm.glasses.od_sph || '0.00',

                glassesAdd: vm.glasses && vm.glasses.add || '0.00',
                glassesDP: vm.glasses && vm.glasses.dp || '50',
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            debouncedSetGlasses: debounce(function(){
                this.setGlasses()
            }, 1000),
            fixDegrees(val){

              val = val.replace(/,/g, '.')

              if(isNaN(Number(val.replace(/º/g, '')))){
                return '0º'
              }

              if(!val.match(/º$/)){
                return `${val}º`
              }

              return val

            },
            async setGlasses(){
                var vm = this

                vm.updatingGlasses = true
                const response = await ApiUtils.makePatch(`indications/${vm.currentProvider.id}/glasses`, null, {

                    oi_degrees: vm.fixDegrees(vm.glassesOIDegrees),
                    oi_cyl: vm.glassesOICyl,
                    oi_sph: vm.glassesOISph,

                    od_degrees: vm.fixDegrees(vm.glassesODDegrees),
                    od_cyl: vm.glassesODCyl,
                    od_sph: vm.glassesODSph,

                    add: vm.glassesAdd,
                    dp: vm.glassesDP,

                    schedule_event_id: vm.eventId

                })
                vm.updatingGlasses = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar lentes')
                    return
                }

                const json = await response.json()
                vm.$emit('update', json.result.glasses)

            },
            zeroPad(val){
                const parts = String(val).split('.')
                if( parts.length === 1) return String(val + '.00')

                return String(`${parts[0]}.${parts[1].length === 2 ? parts[1] : parts[1] + '0'}`)
            }
        },
        computed:{
                ...mapState(['currentProvider']),
            dpOptions(){

                var vm = this
                var options = []

                for(var i = 50; i <= 80; i++){
                    options.push(String(i))
                }

                return options

            },
            addOptions(){

                var vm = this
                var options = []

                for(var i = 0; i <= 3.5; i += .25){
                    var val = i > 0 ? '+' + i : i
                    options.push(String(val))
                }

                return options.map(opt => vm.zeroPad(opt))

            },
            sphOptions(){

                var vm = this
                var options = []

                for(var i = -30; i <= 20; i += 0.25){
                    var val = i > 0 ? '+' + i : i
                    options.push(String(val))
                }

                return options.map(opt =>  vm.zeroPad(opt))

            },
            degrees(){

                var options  = []

                for(var i = 0; i <= 180; i +=5){
                    options.push(String(i) + 'º')
                }

                return options

            },
            cylOptions(){

                var vm = this
                var options = []

                for(var i = -10; i <= 10; i +=.25){
                    var val = i > 0 ? '+' + i : i
                    options.push(String(val))
                }

                return options.map(opt =>  vm.zeroPad(opt))

            }
        },
        watch:{
            glasses(val){

                this.glassesOIDegrees = val && val.oi_degrees || "0.00"
                this.glassesOICyl = val && val.oi_cyl || "0.00"
                this.glassesOISph = val && val.oi_sph || "0.00"

                this.glassesODDegrees = val && val.od_degrees || "0.00"
                this.glassesODCyl = val && val.od_cyl || "0.00"
                this.glassesODSph = val && val.od_sph || "0.00"

                this.glassesAdd = val && val.add || "0.00"
                this.glassesDP = val && val.dp || "00/00"

            },
            glassesOIDegrees(val){
              const vm = this
              vm.debouncedSetGlasses()
            },
            glassesODDegrees(val){
                this.debouncedSetGlasses()
            },
            glassesOICyl(val){
                this.debouncedSetGlasses()
            },
            glassesODCyl(val){
                this.debouncedSetGlasses()
            },
            glassesOISph(val){
                this.debouncedSetGlasses()
            },
            glassesODSph(val){
                this.debouncedSetGlasses()
            },
            glassesAdd(val){
                this.debouncedSetGlasses()
            }
        }
    }
</script>
